import { combineReducers } from 'redux';

import purchases from './ducks/purchases';
import query from './ducks/query';

export default combineReducers({
  query: query.reducer,
  purchases: purchases.reducer,
});
